import { connect } from 'react-redux'
import SetVisibility from './set-visibility'
import { isOpen, getIds } from './set-visibility.selectors'
import { closeSetVisibilityDialog } from './set-visibility.actions'
import { getGroup } from '../../../../../stores/groups/groups.selectors'
import { updateGroup } from '../../../../../stores/groups/groups.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const opened = isOpen(state)
  const ids = getIds(state)
  return {
    opened,
    ids,
    visibility: ids.length === 1 ? getGroup(state, ids[0]).visibility : ''
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  requestClose: () => dispatch(closeSetVisibilityDialog()),
  onSubmit: ({ groupVisibility }) =>
    stateProps.ids.forEach(id =>
      dispatch(
        updateGroup(id, {
          visibility: groupVisibility
        })
      ).catch(errorHandler)
    )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SetVisibility)
